import React from 'react';
import { Button, Popup } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';

const EnabledButton = (props) => {
  return(
    <span>
      <Button
        positive
        content={props.text}
        onClick={props.onSave}/>
    </span>
  );
};

const DisabledButton = (props) => {
  return (
    <Popup
      trigger={
        <span>
          <Button
            disabled
            positive
            content={props.text}
            onClick={props.onSave}/>
        </span>
      }
      content={props.tooltip.join(', ')}
      on='hover'
    />
  );
};


const SaveButtonWithTooltip = (props) => {
  const { text } = props;
  
  if (props.enabled) {
    return <EnabledButton
             onSave={props.onSave}
             text={props.t('common:save')}
           />;
  }  else {
    return <DisabledButton
             onSave={props.onSave} 
             text={text ? text : props.t('common:save')}
             tooltip={props.tooltip}
           />;
  } 
};

export default withNamespaces('private')(SaveButtonWithTooltip);



// WEBPACK FOOTER //
// ./src/private/common/components/SaveButtonWithTooltip/index.js